import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import { MAP_FIT_PADDING, MAP_ZOOM } from '../constants';
import type { MapPosition } from '../types';
import { MAP_FLY_DURATION } from './constants';

export type MapCommand =
  | {
      type: 'fit';
      positions: MapPosition[];
      revision: number;
    }
  | {
      type: 'fly';
      position: MapPosition;
      revision: number;
    };

interface MapControllerParams {
  command: MapCommand;
}

export const MapController = ({ command }: MapControllerParams) => {
  const map = useMap();
  const commandKey = JSON.stringify(command);
  const hasInitializedRef = useRef(false);

  useEffect(() => {
    map.invalidateSize();

    if (command.type === 'fly') {
      map.flyTo(command.position, MAP_ZOOM, {
        duration: hasInitializedRef.current ? MAP_FLY_DURATION : 0,
      });
      hasInitializedRef.current = true;
      return;
    }

    if (command.positions.length === 0) {
      return;
    }

    if (command.positions.length === 1) {
      map.setView(command.positions[0], MAP_ZOOM);
      hasInitializedRef.current = true;
      return;
    }

    map.fitBounds(command.positions, {
      padding: MAP_FIT_PADDING,
      maxZoom: MAP_ZOOM,
    });
    hasInitializedRef.current = true;
  }, [command, commandKey, map]);

  return null;
};
